module.exports = __webpack_public_path__ + "img/arrow-left-black.73eb1791.svg";